import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment'
import base from './base'
import InputTag from 'vue-input-tag'

Vue.config.productionTip = false

Vue.prototype.$moment = moment

Vue.prototype.API_URL = process.env.VUE_APP_BASE_API

Vue.use(ElementUI)
Vue.use(base)
Vue.component('input-tag', InputTag)

/**
 * input自动获取焦点
 */
Vue.directive('inputfocus', {
  inserted (el) {
    el.querySelector('input').focus()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
